/**
 * React 18 compatible replacement for react-client-session
 * Provides the same API as react-client-session but works with React 18
 */

/**
 * React 18 compatible replacement for react-client-session
 * Provides the same API as react-client-session but works with React 18
 */

class SessionManager {
    constructor() {
        this.storeType = 'localStorage'; // default
    }

    setStoreType(type) {
        if (type === 'localStorage' || type === 'sessionStorage') {
            this.storeType = type;
        } else {
            console.warn(`Invalid store type: ${type}. Using localStorage.`);
            this.storeType = 'localStorage';
        }
    }

    get(key) {
        try {
            const storage = this.storeType === 'sessionStorage' 
                ? window.sessionStorage 
                : window.localStorage;
            return storage.getItem(key);
        } catch (error) {
            console.error(`Error getting ${key} from ${this.storeType}:`, error);
            return null;
        }
    }

    set(key, value) {
        try {
            const storage = this.storeType === 'sessionStorage' 
                ? window.sessionStorage 
                : window.localStorage;
            storage.setItem(key, value);
        } catch (error) {
            console.error(`Error setting ${key} in ${this.storeType}:`, error);
        }
    }

    remove(key) {
        try {
            const storage = this.storeType === 'sessionStorage' 
                ? window.sessionStorage 
                : window.localStorage;
            storage.removeItem(key);
        } catch (error) {
            console.error(`Error removing ${key} from ${this.storeType}:`, error);
        }
    }

    clear() {
        try {
            const storage = this.storeType === 'sessionStorage' 
                ? window.sessionStorage 
                : window.localStorage;
            storage.clear();
        } catch (error) {
            console.error(`Error clearing ${this.storeType}:`, error);
        }
    }
}

// Export a singleton instance to match react-client-session's API
export const ReactSession = new SessionManager();

